export var FontUtil = {
 spanDom: null,
 init: function (size, family) {
  this.deInit()
  this.spanDom = document.createElement('span')
  this.spanDom.style.fontSize = size
  this.spanDom.style.lineHeight = size
  this.spanDom.style.opacity = '0'
  this.spanDom.style.fontFamily = family
  document.body.appendChild(this.spanDom)
 },
 computeFontSize: function (str) {
  this.spanDom.innerHTML = str
  let rect = this.spanDom.getBoundingClientRect()
  let sizeD = {width: 0, height: 0}
  sizeD.width = rect.width
  sizeD.height = rect.height
  return sizeD
 },
 deInit: function() {
  if (this.spanDom) {
   document.body.removeChild(this.spanDom)
   this.spanDom = null
  }
 }
};
